function daysBetween(fromISO, toISO) {
  const a = new Date(fromISO + "T00:00:00");
  const b = new Date(toISO + "T00:00:00");
  return Math.round((b - a) / 86400000);
}

export default function DueByPill({ invoice }) {
  const today = new Date().toISOString().slice(0, 10);
  if (invoice.status === "paid") {
    if (!invoice.payment_date) {
      return <span className="text-ink-2">Paid</span>;
    }
    const late = daysBetween(invoice.due_date, invoice.payment_date);
    if (late <= 0) {
      return (
        <span className="inline-flex items-center px-1.5 py-0.5 rounded-sm bg-[color:var(--paid-bg)] text-[color:var(--paid)] text-[11px] font-semibold">
          Paid on time
        </span>
      );
    }
    return (
      <span className="inline-flex items-center px-1.5 py-0.5 rounded-sm bg-[color:var(--pending-bg)] text-[color:var(--pending)] text-[11px] font-semibold">
        Paid {late}d late
      </span>
    );
  }
  const delta = daysBetween(today, invoice.due_date);
  if (delta === 0) {
    return (
      <span className="inline-flex items-center px-1.5 py-0.5 rounded-sm bg-[color:var(--pending-bg)] text-[color:var(--pending)] text-[11px] font-semibold">
        Due today
      </span>
    );
  }
  if (delta > 0) {
    const tone =
      delta <= 3
        ? "bg-[color:var(--pending-bg)] text-[color:var(--pending)]"
        : "bg-[color:var(--aisensy-green-soft)] text-[color:var(--aisensy-dark)]";
    return (
      <span className={`inline-flex items-center px-1.5 py-0.5 rounded-sm text-[11px] font-semibold ${tone}`}>
        In {delta} {delta === 1 ? "day" : "days"}
      </span>
    );
  }
  const overdue = -delta;
  return (
    <span className="inline-flex items-center px-1.5 py-0.5 rounded-sm bg-[color:var(--overdue-bg)] text-[color:var(--overdue)] text-[11px] font-semibold">
      {overdue} {overdue === 1 ? "day" : "days"} overdue
    </span>
  );
}
